import Title from "../Home/Components/Title/Title";
import { useTranslation } from "../../i18n/LanguageProvider";
import useScrollToTop from "../../hooks/useScrollToTop";
import "./About.sass";

function About() {
    const { t } = useTranslation();
    const sections = t("about.sections") || [];

    useScrollToTop();

    return (
        <div className="about general-wrapper">
            <Title text={t("about.title")} />

            <div className="about__content card-common">
                {sections.map((section) => (
                    <section className="about__section" key={section.title}>
                        <h2>{section.title}</h2>
                        {(section.paragraphs || []).map((paragraph) => (
                            <p key={paragraph}>{paragraph}</p>
                        ))}
                        {section.list && (
                            <ul>
                                {section.list.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        )}
                    </section>
                ))}
            </div>
        </div>
    );
}

export default About;
